/**
 * Maps a pathname to the active bottom navigation tab index.
 *
 * @param pathname - The current route pathname
 * @returns The active tab index (0–3) or null if no tab matches
 *
 * Index mapping:
 *   0 = Home (/)
 *   1 = Dives (/dives, /dives/:id)
 *   2 = Create (/dives/create)
 *   3 = Account (/account, /accreditation)
 *   null = No active indicator (e.g. admin routes)
 */
const getActiveIndex = (pathname: string): number | null => {
  if (pathname === '/') return 0
  if (pathname === '/dives/create') return 2
  if (pathname.startsWith('/dives')) return 1
  if (pathname === '/account' || pathname === '/accreditation') return 3
  return null
}

export default getActiveIndex
